import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CryptDataService } from '../security/crypt-data.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../security/crypt-data.service";
var ParametersService = /** @class */ (function () {
    function ParametersService(_http, cryptDataService) {
        this._http = _http;
        this.cryptDataService = cryptDataService;
    }
    ParametersService.prototype.loadApplicationParameters = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = './assets/resources/application_parameters.json';
                        return [4 /*yield*/, this._http.get(url).toPromise().then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return tslib_1.__generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = this;
                                            return [4 /*yield*/, this.cryptDataService.descrypterParameters(response['data'].parameters)];
                                        case 1:
                                            _a.applicationParameters = _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ParametersService.prototype.loadBusinessRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = './assets/resources/business_rules.json';
                        return [4 /*yield*/, this._http.get(url).toPromise().then(function (response) {
                                _this.businessRules = response['data'].business_rules;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ParametersService.prototype.loadApplicationSettings = function (response) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.settings = response.data;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Llena la propiedad con info de archivo json los parametros de contextos de biocatch.
     *
     * * fill property with json file's biocatch context params. *
     *
     */
    ParametersService.prototype.loadBiocatchContext = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = './assets/resources/biocatch_context.json';
                        return [4 /*yield*/, this._http.get(url)
                                .pipe(map(function (data) { return data; }))
                                .toPromise().then(function (res) { return _this.biocatchContextParams = res; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ParametersService.prototype.importContext = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = './assets/resources/import-context.json';
                        return [4 /*yield*/, this._http.get(url)
                                .pipe(map(function (data) { return data; }))
                                .toPromise().then(function (res) { return _this.biocatchContextParams = res; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ParametersService.prototype.getParameter = function (parameterName) {
        return this.applicationParameters[parameterName];
    };
    ParametersService.prototype.getBusinessRule = function (ruleName) {
        return this.businessRules[ruleName];
    };
    ParametersService.prototype.getSetting = function (settingName) {
        return this.settings[settingName];
    };
    /**
     * Expone los parametros de contextos de biocatch.
     *
     * * Exposed Biocatch context params. *
     *
     * @returns Parametros de contextos de biocatch tipados.
     *
     * * Biocatch context params typed *
     */
    ParametersService.prototype.getBiocatchContextParams = function () {
        return this.biocatchContextParams;
    };
    ParametersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ParametersService_Factory() { return new ParametersService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CryptDataService)); }, token: ParametersService, providedIn: "root" });
    return ParametersService;
}());
export { ParametersService };
